export default __webpack_public_path__ + "static/wastetime-ecc3fe878daf0afafd4eb08983ad1b23.svg";